// extracted by mini-css-extract-plugin
module.exports = {"card":"HomeGifCard_card__W6E8n","icon":"HomeGifCard_icon__C8YlN","button-group":"HomeGifCard_button-group__e87Gh","card-button":"HomeGifCard_card-button__vZC_7"};